import { browserHistory } from 'react-router';
import cookie from 'react-cookie';

export const GET_LOGIN_CODE = 'GET_LOGIN_CODE';
export const LOGIN_BY_CODE = 'LOGIN_BY_CODE';
export const RIGISTER_USER = 'RIGISTER_USER';
export const GET_USER_INFO = 'GET_USER_INFO';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const GET_APP_INFO = 'GET_APP_INFO';

export const getLoginCode = (params) =>  (dispatch, getState) => {
    return dispatch({
        CALL_API: {
            type: LOGIN_BY_CODE,
            method: 'post',
            target: '/users/sendCode',
            params
        }
    }).then((response) => {
        if( response && response.pre ) {
            browserHistory.push('/login?pre='+response.pre+'&phone='+params.phoneNum);
        }else {
            browserHistory.push('/signup?phone='+params.phoneNum);
        }
    })
}    

export const loginByCode = (params) =>  (dispatch, getState) => {
    return dispatch({
        CALL_API: {
            type: LOGIN_BY_CODE,
            method: 'post',
            target: '/users/webLogin',
            params
        }
    }).then((response) => {
        //console.log(response);
        if( response && !response.error ) {
            cookie.save('token', response.id, { path: '/'});
            cookie.save('user_id', response.userId, { path: '/'});
            return response;
        }
    })
}

export const registerUser = (data) => (dispatch, getState) => {
    const params = {
        name:data.name,
        phoneNum: data.phoneNum,
        user_type: data.user_type,
        gender: data.gender,
        notification_type: data.notification_type,
        username: data.username,
        email: data.email,
        students: data.students
    }


    return dispatch({
        CALL_API: {
			type: UPDATE_PROFILE,
			method: 'post',
			target: `/users/registerForCustomer`,
			params
		}
    }).then((response) => {
        if(response.error) {
            //alert("請檢查你的欄位正不正確");
            return response;
        }
        else {
            browserHistory.push('/home');
            dispatch(getLoginCode({phoneNum: data.phoneNum}));
        } 
    })
}

export const getUserInfo = (params) => (dispatch, getState) => {
    return dispatch({
        CALL_API: {
			type: GET_USER_INFO,
			method: 'get',
			target: '/users/whoami',
            header: {
                Authorization: cookie.load('token')
            },
			params
		}
    }).then((response) => {
        //if( response.error ) browserHistory.push('/home');
        return response;
    })
}

export const updateProfile = (data) => (dispatch, getState) => {
    const params = {
        name: data.name,
        phoneNum: data.phoneNum,
        user_type: data.user_type,
        gender: data.gender,
        notification_type: data.notification_type,
        username: data.username,
        email: data.email,
        students: data.students
    }

    const user_id = getState().data.user.id;

    return dispatch({
        CALL_API: {
			type: UPDATE_PROFILE,
			method: 'post',
			target: `/users/${user_id}/transactionUpdate`,
            header: {
                Authorization: cookie.load('token')
            },
			params
		}
    }).then((response) => {
        if(response.error) alert("請檢查你的欄位正不正確");
        else {
            alert("更新成功！");
        } 
    })
}

export function getAppInfo() {
    const filter = {
        order: "id desc"
    }
    return {
        CALL_API: {
			type: GET_APP_INFO,
			method: 'post',
			target: `/app_info/findOne?filter=${filter}`,
		}
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/user.js
 **/